import React, { useEffect } from 'react';
import styles from './action-modal.module.scss';
import Modal from '../Modal';
import Button from '../Button';
import { JsxElement } from 'typescript';
import { PiSealWarningFill } from 'react-icons/pi';
import { RiDeleteBin6Line } from 'react-icons/ri';
interface ButtonProps {
	type:
		| 'light'
		| 'primary'
		| 'secondary'
		| 'danger'
		| 'danger-outline'
		| 'success'
		| 'warning'
		| 'light'
		| 'register'
		| 'order'
		| 'general'
		| 'warning-outline';

	size?: 'small' | 'medium' | 'large';
	rounded?: boolean;
	label: string | JsxElement | any;
	className?: string;
	onClick?: () => void;
	style?: any;
	lableClass?: any;
}
interface Props {
	title: string;
	message?: string;
	confirmText?: string;
	cancelText?: string;
	onConfirm: () => void;
	onCancel?: () => void;
	isVisible: boolean;
	buttonProps?: ButtonProps | null;
	type?: 'warning' | 'danger' | 'success' | 'primary' | 'light' | 'secondary';
}

const ConfirmModal: React.FC<Props> = ({
	title,
	message = 'Are you sure?',
	confirmText = 'Confirm',
	cancelText = 'Cancel',
	onConfirm,
	onCancel,
	type = 'warning',
	// buttonProps = {
	// 	label: "Confirm",
	// 	type: "primary",
	// 	size: "large",
	// 	rounded: false,
	// 	className: "",
	// 	onClick: () => {},
	// 	style: {},
	// 	lableClass: "",
	// },
	buttonProps,
	isVisible
}) => {
	const [isVisibles, setIsVisible] = React.useState(false);

	const handleCancel = () => {
		if (onCancel) {
			onCancel();
		}
		setIsVisible(false);
	};

	const handleOpen = () => {
		setIsVisible(true);
	};

	const handleConfirm = () => {
		onConfirm();
		setIsVisible(false);
	};

	useEffect(() => {
		setIsVisible(isVisible);
	}, [isVisible]);

	return (
		<>
			{buttonProps && <Button {...buttonProps} onClick={handleOpen} />}
			<Modal
				isOpen={isVisibles}
				onClose={handleCancel}
				footer={null}
				width={432}
				bodyStyle={{
					borderRadius: '15px'
				}}>
				<div className={styles.confirmModal}>
					<div className={styles.icon + ' ' + styles[type]}>
						{type === 'warning' && <PiSealWarningFill />}
						{type === 'danger' && <RiDeleteBin6Line />}
					</div>

					<div className={styles.content}>
						<div className={styles.title}>{title}</div>
						<div className={styles.message}>{message}</div>
					</div>

					<div className={styles.footer}>
						<Button
							label={cancelText}
							type='danger-outline'
							size='large'
							className={styles.button}
							onClick={handleCancel}
						/>
						<Button
							label={confirmText}
							className={styles.button}
							type='primary'
							size='large'
							onClick={handleConfirm}
						/>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default ConfirmModal;
